// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"vendors-node_modules_fortawesome_fontawesome-svg-core_index_mjs":"5b67ba","vendors-node_modules_fortawesome_pro-solid-svg-icons_index_mjs":"c8b679"}[chunkId] + ".js";
};